import UserPage from './UsersPage';

export default UserPage;
